import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BrowserIdService } from '@services/browser-id.service';

@Injectable()
export class BrowserIdInterceptor implements HttpInterceptor {

  constructor(private browserIdService: BrowserIdService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const browserId = this.browserIdService.getBrowserId();
    console.info('interceptor called ', browserId);
    const clonedRequest = req.clone({
      setHeaders: {
        'x-browser-id': browserId
      }
    });

    return next.handle(clonedRequest);
  }
}
